import { LoadingButton } from '@mui/lab';
import SearchIcon from '@mui/icons-material/Search';

export default function LoadingSearchButton({ onClick, loading }) {
  return (
    <LoadingButton
      variant="contained"
      color="primary"
      onClick={onClick}
      loading={loading}
      startIcon={<SearchIcon />}
    >
      Buscar
    </LoadingButton>
  );
}
